/**
 * Register the service worker, so the app can be installed.
 *
 * `public/sw.js` explains what it does (almost nothing) and why it has to
 * exist at all. This file is only the switch that turns it on.
 *
 * ── Two details that matter ──────────────────────────────────────────────
 *
 * The path is RELATIVE, not `/sw.js`. `package.json` sets `homepage: "./"`,
 * so the build is designed to work from wherever it is served rather than
 * only from a domain root — and a relative registration follows that. The app
 * uses HashRouter, so `window.location.pathname` is always the page the app
 * was served from whatever screen somebody is on, and `sw.js` resolves beside
 * it every time. A hardcoded `/sw.js` would break the day this is served from
 * a subfolder.
 *
 * It waits for `load`. Registering during start-up competes with the bundle
 * and the first API calls for the same connection, on tills that are often on
 * a slow one.
 *
 * Failure is swallowed on purpose. A service worker that will not register —
 * an unsupported browser, a page opened over plain http, a locked-down
 * machine — must never be the reason the till does not start. The only thing
 * lost is the Install button, which simply never appears.
 */
export default function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    try {
      navigator.serviceWorker.register('sw.js').catch(() => {
        /* no install button; the app is unaffected */
      });
    } catch (err) {
      /* same */
    }
  });
}
